import Image from 'next/image';

const LineItemThumbnail = ({ item }) => {
  const product = item?.merchandise?.product;
  if (!product?.featuredImage?.url) {
    console.warn('No featured thumbnail for line item:', product.title);
    return null;
  }

  return (
    <div className="relative overflow-hidden">
      {/* Breakpoint and fit follow production: it switches at md, and scales the
          image down to fit rather than cropping it. The container in CartContent
          is md:w-24, so using lg here left the image 40px smaller than its box
          between 768px and 1024px. */}
      <Image
        className="h-14 w-14 object-scale-down md:h-24 md:w-24"
        width="96"
        height="96"
        sizes="(min-width: 768px) 96px, 56px"
        alt={
          product.featuredImage.altText ?? product.title ?? 'Product thumbnail'
        }
        src={product.featuredImage.url}
      />
    </div>
  );
};

export default LineItemThumbnail;
